import React, {FC} from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as TsSvg} from "../assets/team-shuffle-text.svg"


export const Header: FC = () => {
    return (
        <div className="w-full flex justify-center">
            <div className='w-full max-w-[1240px] flex'>
                    <Link to='/'>
                        <TsSvg className="pt-7 w-[80%]" />
                    </Link>
            </div>
        </div>
    );
};

